import React from "react";
import SearchResultPage from "../../../templates/search-results-template";

const SearchResultCommSales = (props) => {

    const fullpath = props.location.pathname
    const location = props.location
    const fullpathone = props.location
    // const searchParams = parseSearchUrl("sales", fullpath);

    return (
        <React.Fragment>
            <SearchResultPage 
                locationname="/commercial-property/for-sale/" 
                pcategorytype="commercial" 
                ptype="sales" 
                ptypetag="for-sale" 
                pstatustype="For Sale"
                fullpathone={fullpathone} 
                fullpathname={fullpath}
                {...props}
                tag={"commercial"}
            />
        </React.Fragment>
    );
};

export default SearchResultCommSales;
